export default {
  API_ENDPOINT: 'https://spanimal.herokuapp.com/api',
  TOKEN_KEY: 'blogful-client-auth-token',
}
